import * as events from 'eventlistener';

let xde;
let DEFAULT_ORIGIN = '*'; // or array of valid domains
let eventListeners = {};
const win = window;
let parentOrigin = DEFAULT_ORIGIN;

function onMessage(evt) {
    let parsedData;

    if (typeof xde.targetOrigin === 'string') {
        if (xde.targetOrigin != DEFAULT_ORIGIN && evt.origin !== xde.targetOrigin) {
            return;
        }
    }

    if (Array.isArray(xde.targetOrigin)) {
        if(xde.targetOrigin.indexOf(evt.origin) < 0) {
            return;
        }
    }


    parsedData = evt.data;
    if (typeof evt.data == 'string' && evt.data[0] === '{') {
        try {
            parsedData = JSON.parse(evt.data);
        } catch (e) {
            console.log(e);
        }
    }

    if (!parsedData || parsedData.__xde !== true) {
        return;
    }

    parsedData.origin = evt.origin;
    parsedData.source = evt.source;

    let listeners = eventListeners[parsedData.name];
    if (listeners && listeners.length > 0) {
        listeners.forEach(function (fn) {
            fn(parsedData);
        });
    }
}

function validateName(name) {
    if (!name || typeof name != 'string') {
        throw new Error('Event name has to be a string');
    }
}

function validateNameAndFn(name, fn) {
    validateName(name);
    if (typeof fn != 'function') {
        throw new Error('Callback function has to be given');
    }
}
/**
 * @typedef XDE
 * @type {Object}
 * @prop {Function} on  Function to subscribe to cross domain events via postMessage
 * @prop {Function} off  Function to unsubscribe to cross domain events via postMessage
 * @prop {Function} sendTo  Function to send data to another window via postMessage API
 * @prop {Function} targetOrigin  The intended target for the postMessage
 * @prop {Function} onlyStringSupport Flag to check if only string data transport is supported
 * @prop {Function} setOrigin Function to set the parent origin from or to which the data needs to be sent
 */
xde = {
    /**
     * Function to subscribe to cross domain events via postMessage
     * @param {String} name The name of the event to listen to
     * @param {Function} fn The callback function to trigger on receiving the event
     */
    on: function (name, fn) {
        validateNameAndFn(name, fn);

        if (typeof eventListeners[name] == 'undefined') {
            eventListeners[name] = [];
        }
        eventListeners[name].push(fn);
    },
    /**
     * Function to unsubscribe to cross domain events via postMessage
     * @param {String} name The name of the event to unsubscribe
     * @param {Function} fn The callback function to unsubscribe
     */
    off: function (name, fn) {
        validateNameAndFn(name, fn);
        let listeners = eventListeners[name];
        if (!listeners) {
            return;
        }
        eventListeners[name] = listeners.filter(function (listener) {
            return listener !== fn;
        });
    },
    /**
     * Function to send data to another window via postMessage API
     * @param {Object} otherWindow The window object
     * @param {String} name The name of the event to trigger
     * @param {Object} datew The data object to be sent
     */
    sendTo: function (otherWindow, name, data) {
        validateName(name);
        try {
            if (otherWindow && otherWindow.contentWindow) {
                otherWindow = otherWindow.contentWindow;
            }
        } catch (e) {}
        if (!otherWindow || !otherWindow.postMessage) {
            throw new TypeError('otherWindow does not support postMessage');
        }

        let msg = {
            name: name,
            data: data,
            __xde: true
        };
        if (xde.onlyStringSupport) {
            msg = JSON.stringify(msg);
        }
        if(typeof xde.targetOrigin === 'string') {
            otherWindow.postMessage(msg, xde.targetOrigin); // TODO fix security issue
        }
        if(Array.isArray(xde.targetOrigin)) {
            xde.targetOrigin.forEach(origin => {
                if(origin === parentOrigin) {
                    otherWindow.postMessage(msg, origin); // TODO fix security issue
                }
            });
        }
    },
    /**
     * The intended target for the postMessage
     * @default *
     */
    targetOrigin: DEFAULT_ORIGIN,
    /**
     * Flag to check if only string data transport is supported
     */
    onlyStringSupport: false,
    /**
     * Function to set the parent origin from or to which the data needs to be sent
     * @param {String} origin The orgin of the parent window
     */
    setOrigin: function(origin){
        parentOrigin = origin || DEFAULT_ORIGIN;
    },
    /**
     * Function to reset the cross domain event listeners.
     */
    _reset: function () {
        eventListeners = {};
        this.targetOrigin = DEFAULT_ORIGIN;
    }

};

function featureTestObjectTransportSupport() {
    try {
        win.postMessage({
            toString: function () {
                xde.onlyStringSupport = true;
            }
        }, DEFAULT_ORIGIN);
    } catch (e) {
    // console.log(`Object transport supported`);
    }
}

featureTestObjectTransportSupport();

events.add(win, 'message', onMessage, false);

export default xde;


// WEBPACK FOOTER //
// ./src/xde.js